import { ProgressBarDesignTokens } from '@primeuix/themes/types/progressbar';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/progressbar/index.ts
const pb = componentCommon.progressbar;

export const ProgressbarTelekomDT: ProgressBarDesignTokens = {
  root: {
    background: t(pb.background),
    borderRadius: t(pb.border.radius),
    height: t(pb.height),
  },
  value: {
    background: t(pb.value.background),
  },
  label: {
    color: t(pb.label.color),
    fontSize: t(pb.label.font.size),
    fontWeight: tNum(pb.label.font.weight),
  },
};
